// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"e83f6309","370":"086d4d3d","415":"086d4d3d","518":"086d4d3d","544":"086d4d3d"}[chunkId] + ".chunk.css";
};